export default [
  {
    path: '/store/edit',
    name: 'stores-edit',
    component: () => import('@/views/stores/store-config/storeEdit.vue'),
  },
  {
    path: '/stores',
    name: 'stores',
    component: () => import('@/views/stores/index.vue'),
  },
]
